export default function App() {
  return (
    <main style={{ padding: '2rem', fontFamily: 'system-ui' }}>
      <h1>Liste de Naissance</h1>
      <p>Plateforme en construction. Revenez bientôt.</p>
    </main>
  )
}
